import { useEffect, useRef } from 'react';

const modalStack = [];

/**
 * Gives every portal modal the same keyboard and scroll-lock behavior.
 * Only the topmost modal responds to Escape, so nested confirmations do not
 * accidentally dismiss the layer underneath them.
 */
export const useModalDismiss = ({ isOpen, onClose }) => {
  const modalIdRef = useRef(Symbol('modal'));
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const modalId = modalIdRef.current;
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape' || modalStack[modalStack.length - 1] !== modalId) return;
      event.preventDefault();
      onCloseRef.current?.();
    };

    modalStack.push(modalId);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      const stackIndex = modalStack.indexOf(modalId);
      if (stackIndex !== -1) modalStack.splice(stackIndex, 1);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);
};
